import React, { useEffect, useState } from 'react';
import { Modal, Spinner, ModalBody, ModalHeader, ModalFooter, Button, Col, FormGroup, Label, Input, Row, Card, CardHeader, CardBody } from 'reactstrap';
import DatePicker from 'react-datepicker'
import Select from '../../Template/Input/Select';
import MaskedInput from '../../Template/Input/MaskedInput';
import AddFilesCard from '../../../pages/Admin/AddFilesCard';
import { notifyError, notifySuccess } from '../../../utils/notify';
import oikosApi from '../../../services/oikos';
import moment from 'moment';

// This component must recieve the openModal which is the variable that makes the modal render.
// This component must recieve the onClosed function which is the function that change the variable openModal.
// Both openModal variable and onClosed function should be defined in the parent component of this Modal.

const ModalFormDocumentos = ( { openModal, title, size='sm', subtitle, tabela, onClosed, onConfirm, data, confirmButtonColor='primary', confirmButtonText = 'Confirmar', cancelButtonText = 'Cancelar' } ) => {

    const [inputs, setInputs] = useState({});
    const [addDocumentIsLoading, setAddDocumentIsLoading] = useState(false);
    const newFilesRef = React.createRef();

    const checkCamposObrigatorios = () => {
      for (const campo of data) {
        if (campo.tpDocumentoCampo_obrigatorio === 1 && !inputs[campo.tpDocumentoCampo_label]) {
          notifyError(`O campo "${campo.tpDocumentoCampo_label}" é obrigatório.`)
          return false
        }
      }
      return true
    }

    const handleAddDocument = async () => {
      setAddDocumentIsLoading(true);

      const newFiles = newFilesRef?.current?.state?.files

      if (!checkCamposObrigatorios()) {
        setAddDocumentIsLoading(false);
       return;
      }

      const documentBody = {
          action: 'insert',
          table: 'documento',
          data: {
            tpDocumento_id: data[0].tpDocumento_id || undefined,
            documento_desc: inputs.documento_desc || undefined,
            documento_iniVig: inputs.documento_iniVig ? moment(inputs.documento_iniVig).format('YYYY-MM-DD') : undefined,
            documento_fimVig: inputs.documento_fimVig ? moment(inputs.documento_fimVig).format('YYYY-MM-DD') : undefined,
            documento_dtEmissao: inputs.documento_dtEmissao ? moment(inputs.documento_dtEmissao).format('YYYY-MM-DD') : undefined,
            documento_prazo: inputs.documento_prazo || undefined,
            documento_ref: inputs.documento_ref || undefined,
            privacidade_id: inputs.privacidade_id || 2,
          },
      }

      const documentCreated = await oikosApi.post('/', documentBody);

      if (documentCreated.data[0]?.documento_id) {
        for (const campo of data) {
          let campoBody = {}
          if(campo.formatoCampo_id === 6) {
            campoBody = {
              action: 'insert',
              table: 'documentoDado',
              data: {
                documento_id: documentCreated.data[0].documento_id,
                tpDocumentoCampo_id: campo.tpDocumentoCampo_id,
                documentoDado_valor: moment(inputs[campo.tpDocumentoCampo_label]).format('YYYY-MM-DD') || null,
              },
            }
          } else {
            campoBody = {
              action: 'insert',
              table: 'documentoDado',
              data: {
                documento_id: documentCreated.data[0].documento_id,
                tpDocumentoCampo_id: campo.tpDocumentoCampo_id,
                documentoDado_valor: inputs[campo.tpDocumentoCampo_label] || null,
              },
            }
          }

          const res = await oikosApi.post('/', campoBody)
          console.log(res)
        }
      }

      let tablesArray = [];

      /*
      for (const item of data) {
        if (item.tpDocumentoCampo_tabRef && tablesArray.filter(tab => tab === item.tpDocumentoCampo_tabRef).length === 0) {
          tablesArray.push({tpDocumentoCampo_tabRef: item.tpDocumentoCampo_tabRef, tpDocumentoCampo_tabId: item.tpDocumentoCampo_tabId});
        }
      }

      if (documentCreated.data[0]?.documento_id && tablesArray.length > 0) {
        await Promise.all(tablesArray.map(async vinculation => {
          const vinculationBody = {
            action: 'insert',
            table: 'documentoVinc',
            data: {
              documento_id: documentCreated.data[0].documento_id,
              documentoVinc_tabRef: vinculation.tpDocumentoCampo_tabRef,
              documentoVinc_tabId: vinculation.tpDocumentoCampo_tabId,
            },
          }

          await oikosApi.post('/', vinculationBody)
        }))
      }

       if (documentCreated.data[0]?.documento_id && newFiles.length > 0) {
         await Promise.all(newFiles.map(async file => {
           const formData = new FormData()
           formData.append('file', new Blob([file.data], { type: file.data.type }), file.data.path)
           formData.append('table', 'arquivo')
           formData.append('action', 'upload_file')
           formData.append('arquivo_tabRef', 'documento')
           formData.append('arquivo_tabId', documentCreated.data[0].documento_id)
           formData.append('arquivo_privacidade', documentCreated.data[0].privacidade_id)
           formData.append('arquivo_desc', file.data.path)

           const res = await oikosApi.post('/', formData)
           console.tron.log('res upload_file', res)
         }))
       }
      */

      setAddDocumentIsLoading(false);

    }


    /*

    const handleAddDocumentDinamicFields = async () => {
      setAddDocumentIsLoading(true);

      const newFiles = newFilesRef?.current?.state?.files

      if (!checkCamposObrigatorios()) {
        setAddDocumentIsLoading(false);
        return;
      }

      try {
        const documentBody = {
          action: 'insert',
          table: 'documento',
          data: {
            tpDocumento_id: data[0].tpDocumento_id || undefined,
            documento_desc: inputs.documento_desc || undefined,
            documento_iniVig: inputs.documento_iniVig ? moment(inputs.documento_iniVig).format('YYYY-MM-DD') : undefined,
            documento_fimVig: inputs.documento_fimVig ? moment(inputs.documento_fimVig).format('YYYY-MM-DD') : undefined,
            documento_dtEmissao: inputs.documento_dtEmissao ? moment(inputs.documento_dtEmissao).format('YYYY-MM-DD') : undefined,
            documento_prazo: inputs.documento_prazo || undefined,
            documento_ref: inputs.documento_ref || undefined,
            privacidade_id: inputs.privacidade_id || 2,
          },
        }

        const documentCreated = await oikosApi.post('/', documentBody)

        let tablesArray = [];

        for (const item of data) {
          if (item.tpDocumentoCampo_tabRef && tablesArray.filter(tab => tab === item.tpDocumentoCampo_tabRef).length === 0) {
            tablesArray.push({tpDocumentoCampo_tabRef: item.tpDocumentoCampo_tabRef, tpDocumentoCampo_tabId: item.tpDocumentoCampo_tabId});
          }
        }

        if (documentCreated.data[0]?.documento_id && tablesArray.length > 0) {
          await Promise.all(tablesArray.map(async vinculation => {
            const vinculationBody = {
              action: 'insert',
              table: 'documentoVinc',
              data: {
                documento_id: documentCreated.data[0].documento_id,
                documentoVinc_tabRef: ,
                documentoVinc_tabId: ,
              },
            }

            await oikosApi.post('/', vinculationBody)
          }))
        }

        if (documentCreated.data[0]?.documento_id && newFiles.length > 0) {
          await Promise.all(newFiles.map(async file => {
            const formData = new FormData()
            formData.append('file', new Blob([file.data], { type: file.data.type }), file.data.path)
            formData.append('table', 'arquivo')
            formData.append('action', 'upload_file')
            formData.append('arquivo_tabRef', 'documento')
            formData.append('arquivo_tabId', documentCreated.data[0].documento_id)
            formData.append('arquivo_privacidade', documentCreated.data[0].privacidade_id)
            formData.append('arquivo_desc', file.data.path)

            const res = await oikosApi.post('/', formData)
            console.tron.log('res upload_file', res)
          }))
        }

        if (documentCreated.data[0]?.documento_id) {
          for (const campo of this.state.campos) {
            let campoBody = {}
            if(campo.tpDocumentoCampo_type === 'DATETIME') {
              campoBody = {
                action: 'insert',
                table: 'documentoDado',
                data: {
                  documento_id: documentCreated.data[0].documento_id,
                  tpDocumentoCampo_id: campo.tpDocumentoCampo_id,
                  documentoDado_valor: moment(inputs[campo.tpDocumentoCampo_label]).format('YYYY-MM-DD') || null,
                },
              }
            } else {
              campoBody = {
                action: 'insert',
                table: 'documentoDado',
                data: {
                  documento_id: documentCreated.data[0].documento_id,
                  tpDocumentoCampo_id: campo.tpDocumentoCampo_id,
                  documentoDado_valor: inputs[campo.tpDocumentoCampo_label] || null,
                },
              }
            }

            const res = await oikosApi.post('/', campoBody)
            console.log(res)
          }
        }

        notifySuccess('Documento adicionado com sucesso.')
        this.setState({ addDocumentIsLoading: false, addDocumentModalIsOpen: false })
        //this.props.getDocuments()
        //this.getDocumentsVinculations()
      } catch (e) {
        notifyError('Não foi possível adicionar o documento.')
        console.tron.log('Não foi possível adicionar o documento.', e)
        this.setState({ addDocumentIsLoading: false })
      }
    }
    */


    return (
        <Modal size={size} isOpen={openModal} toggle={onClosed} centered zIndex={2000}>
            <div className='d-flex justify-content-between align-items-center pt-3 pr-4 pl-4'>
              <strong className='text-danger'>{title}</strong>
              <strong onClick={onClosed} style={{cursor: "pointer"}}>
                <i className="ri-close-line" />
              </strong>
            </div>
            <ModalBody>
                {subtitle &&
                  <h5>{subtitle}</h5>
                }
              <Row xs={1} sm={2} lg={4}>
                {/*
                <Col sm={3}>
                  <FormGroup>
                    <Label>
                      Descrição
                    </Label>
                    <Input
                      value={ inputs.documento_desc ? inputs['documento_desc'] : null }
                      onChange={e => setInputs({ ...inputs, documento_desc: e.target.value })}
                    />
                  </FormGroup>
                </Col>
                */}
                {data.map((campo, index) => {
                    if (campo.formatoCampo_id === 6) {
                      return (
                        <Col sm={campo.sm} key={index}>
                          <FormGroup>
                            <Label>
                              {campo.tpDocumentoCampo_label}
                            </Label>
                            <DatePicker
                              placeholderText="__/__/_____"
                              locale="pt-BR"
                              className="form-control"
                              dateFormat="dd/MM/yyyy"
                              peekNextMonth
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                              selected={inputs[campo.tpDocumentoCampo_label] ? moment(inputs[campo.tpDocumentoCampo_label]).toDate() : null}
                              onChange={date => setInputs({...inputs, [campo.tpDocumentoCampo_label]: date } )}
                            />
                          </FormGroup>
                        </Col>
                      )
                    }

                    if (campo.formatoCampo_id === 3) {
                      return (
                        <Col sm={campo.sm} key={index}>
                          <FormGroup>
                            <Label>
                              {campo.tpDocumentoCampo_label}
                            </Label>
                            <Input
                              value={ inputs[campo.tpDocumentoCampo_label] ? inputs[campo.tpDocumentoCampo_label] : null }
                              onChange={e => setInputs({ ...inputs, [campo.tpDocumentoCampo_label]: e.target.value })}
                            />
                          </FormGroup>
                        </Col>
                      )
                    }

                    if (campo.formatoCampo_id === 1) {
                      return (
                        <Col sm={campo.sm} key={index}>
                          <FormGroup>
                            <Label>
                              {campo.tpDocumentoCampo_label}
                            </Label>
                            <Select
                              isSearchable
                              isClearable
                              options={data ? data.find(c => c.tpDocumentoCampo_id === campo.tpDocumentoCampo_id).selOptions : []}
                              value={inputs[campo.tpDocumentoCampo_label] ? data.find(c => c.tpDocumentoCampo_id === campo.tpDocumentoCampo_id).selOptions.filter(op => op.value === inputs[campo.tpDocumentoCampo_label]) : null}
                              onChange={e => setInputs({ ...inputs, [campo.tpDocumentoCampo_label]: e.value })}
                            />
                          </FormGroup>
                        </Col>
                      )
                    }

                    if (campo.formatoCampo_id === 2) {
                      return (
                        <Col sm={campo.sm} key={index}>
                          <FormGroup>
                            <Label>
                              {campo.tpDocumentoCampo_label}
                            </Label>
                            <MaskedInput
                              unmask
                              mask="R$ num"
                              blocks={{
                                num: {
                                  mask: Number,
                                  scale: 2, // digits after point 0 for integers
                                  signed: false, // disallow negative
                                  thousandsSeparator: '.', // any single char
                                  padFractionalZeros: false, // if true then pads zeros at end to the length of scale
                                  normalizeZeros: false, // appends or removes zeros at ends
                                  radix: ',', // fractional delimiter
                                  min: 0,
                                  max: 1000000000,
                                },
                              }}
                              lazy={false}
                              value={inputs ? inputs[campo.tpDocumentoCampo_label] : ''}
                              onAccept={value => setInputs({ ...inputs, [campo.tpDocumentoCampo_label]: value })}
                            />
                          </FormGroup>
                        </Col>
                      )
                    }

                    if (campo.formatoCampo_id === 4) {
                      return (
                        <Col sm={campo.sm} key={index}>
                          <FormGroup>
                            <Label>
                              {campo.tpDocumentoCampo_label}
                            </Label>
                            <Input
                              type='number'
                              value={ inputs ? inputs[campo.tpDocumentoCampo_label] : null }
                              onChange={e => {
                                console.log(campo.tpDocumentoCampo_label)
                                setInputs({ ...inputs, [campo.tpDocumentoCampo_label]: Number(e.target.value) });
                              }}
                            />
                          </FormGroup>
                        </Col>
                      )
                    }
                })}
              </Row>

              <Row>
                <Col>
                  <Card>
                    <CardHeader>
                      Anexos
                    </CardHeader>
                    <CardBody>
                      <AddFilesCard ref={newFilesRef} />
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button color={confirmButtonColor} onClick={handleAddDocument}>{confirmButtonText}</Button>
              <Button onClick={onClosed}>{cancelButtonText}</Button>
              <Button onClick={() => {console.log(inputs)}}>inputs</Button>
            </ModalFooter>
        </Modal>
    )
}

export default ModalFormDocumentos;
